
<div class="draggable-marker" :class="classes" @mousedown.stop></div>
